import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWallet } from "@solana/wallet-adapter-react";

const UnauthorizedGuard = () => {
  const navigate = useNavigate();
  const { connected } = useWallet();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          if (!connected) {
            navigate("/go");
          }
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, connected]);

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-4">
      <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-8 shadow-xl border border-gray-200/50 max-w-md w-full mx-4 text-center">
        <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
          <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <h2 className="text-2xl font-bold mb-2 text-gray-900">NO ACCESS</h2>
        <p className="text-gray-600 mb-6">{!connected ? "Please connect your wallet to access this page" : "Your current connected wallet is not authorized for this page"}</p>

        {connected ? (
          <button onClick={() => navigate("/go/dashboard")} className="bg-secondary hover:bg-secondary/90 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-300 w-full">
            Go to Dashboard
          </button>
        ) : (
          <p className="text-sm text-gray-500">Redirecting to home in {countdown} seconds...</p>
        )}
      </div>
    </div>
  );
};

export default UnauthorizedGuard;
